import { Heading } from '../Heading/Heading'
import { JuicerComponent } from '../Juicer/Juicer'
import './SocialWall.css'
import iglogo from '../../assets/icon-instagram.svg'
import ytlogo from '../../assets/icon-youtube.svg'
import { useTranslate } from '../../TranslationsContext'
import { Container } from '../Container/Container'

export function SocialWall() {
  const translate = useTranslate()

  return (
    <div className="SocialWall">
      <JuicerComponent />
      <Heading type="Section">#CeramolAcn3</Heading>
      <Container className="socialLogos">
        <h3>{translate('SocialWall.text')}</h3>
        <nav className="socialLinks">
          <a href={translate('SocialWall.icons.instagram.url')}>
            <img src={iglogo} alt="Instagram" />
          </a>
          <a href={translate('SocialWall.icons.youtube.url')}>
            <img src={ytlogo} alt="YouTube" />
          </a>
        </nav>
      </Container>
    </div>
  )
}
